export default __webpack_public_path__ + "static/media/maxmin.60f17a68.png";